import React, { Fragment, useState, useEffect } from 'react';
import axios from 'axios';
import clsx from 'clsx';
import {
  Box,
  makeStyles
} from '@material-ui/core';
import StatusDataContext from '../../../contexts/StatusDataContext';
import Footer from '../../footer/Footer';
import DataTable from 'react-data-table-component';

const customStyles = {
  rows: {
      style: {
        minHeight: '5px', // override the row height
        
      },
  },
  headCells: {
      style: {
          paddingLeft: '1px', // override the cell padding for head cells
          paddingRight: '1px',
          width: '5px'
      },
  },
  cells: {
      style: {
          paddingLeft: '1px', // override the cell padding for data cells
          paddingRight: '1px',
          width: '5px'
      },
  },
};

const RepairsDetailed = ({ uuid, mesTemperatures, typeAnita, className, ...rest }) => {
  const [columnsFirst, setColumnsFirst] = useState([]);

  const [ColumnsSecond, setColumnsSecond] = useState([]);
  const [data, setData] = useState([]);

  const [dataDeux, setDataDeux] = useState([]);

  const getTrProps = (state, rowInfo) => {
    try {
      if (rowInfo && rowInfo.row) {
        return {
          onClick: (e) => {
            this.setState({
              selected: rowInfo.index
            })
          },
          style: {
            background: rowInfo.index === this.state.selected ? '#00afec' : 'white',
            color: rowInfo.index === this.state.selected ? 'white' : 'black'
          }
        }
      } else {
        return {}
      }
    }
    catch (e) { alert('no') }
  }

  useEffect(() => {
    const list = [];
    const list2 = [];
    
    const  columnSecond = mesTemperatures[0].slice(0,2).concat(mesTemperatures[0].slice((typeAnita[0]==='12'?6:12)+2,((typeAnita[0]==='12'?6:12)+2)*2-2 ).concat(mesTemperatures[0].slice(mesTemperatures[0].length-4,mesTemperatures[0].length)) );
    const columnFirstHalf =  mesTemperatures[0].slice(0,(typeAnita[0]==='12'?6:12)+2).concat(mesTemperatures[0].slice(mesTemperatures[0].length-4,mesTemperatures[0].length));

    
    for (let i = 1; i < mesTemperatures.length - 1; i++) {
      const obj = {};
      const obj2 = {};
      const currentSecond = mesTemperatures[i].slice(0,2).concat(mesTemperatures[i].slice((typeAnita[0]==='12'?6:12)+2,((typeAnita[0]==='12'?6:12)+2)*2-2 ).concat(mesTemperatures[i].slice(mesTemperatures[i].length-4,mesTemperatures[i].length)) );
      const currentFirst =  mesTemperatures[i].slice(0,(typeAnita[0]==='12'?6:12)+2).concat(mesTemperatures[i].slice(mesTemperatures[i].length-4,mesTemperatures[i].length));
  
      for (let j = 0; j < mesTemperatures[i].length ; j++) 
      {
         obj[columnFirstHalf[j]] = currentFirst[j]*1;
         obj2[columnSecond[j]] = currentSecond[j]*1;
      }
      list.push(obj);
      list2.push(obj2);
    }
    setData(list);
    setDataDeux(list2);
    const columns = columnFirstHalf.map(c => ({
      name: c,
      selector: c,
      sortable: true,


    }));
    const columnss = columnSecond.map(c => ({
      name: c,
      selector: c,
      sortable: true

    }));
    setColumnsFirst(columns);
    setColumnsSecond(columnss);
    

  }, [])
  //<CustomTable uuid={uuid} title={"Measurements"}  path={'/measuresPwr/'}></CustomTable>
  const conditionalRowStyles = [
    {
      when: row => row < 20,
      style: {
        backgroundColor: 'green',
        color: 'white',
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
    // You can also pass a callback to style for additional customization
    
  ];
  return (
    <StatusDataContext.Provider >
      <Fragment>

        <Box flexGrow={1} >
           
            <center>
              
            <h4 style={{color:'Orange'}}>Zone 1 :</h4>
            <DataTable
            customStyles={customStyles}
            conditionalRowStyles={conditionalRowStyles}
            style={{ width: '50px' }}
            pagination
            highlightOnHover
            columns={columnsFirst}
            data={data}
          />
          <h4 style={{color:'Blue'}}>Zone 2 :</h4><DataTable
          customStyles={customStyles}
              style={{ width: '100px' }}
              pagination
              highlightOnHover
              columns={ColumnsSecond}
              data={dataDeux}
              
            />
            </center>

        </Box>

        
      </Fragment>

    </StatusDataContext.Provider>
  )
}

export default RepairsDetailed;
